import React, { useEffect, useState } from 'react';
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import BarChart from "./BarComponent";
import axios from 'axios';
import { Select, DatePicker, Divider, Typography } from 'antd';
import {formatDateWithTimezoneOffset} from '../../lib/lib';
import moment from 'moment';
import dayjs from 'dayjs';
import StableDatePicker from '../common/StableDatePicker';
Chart.register(CategoryScale);
const { Option } = Select;
const { RangePicker } = DatePicker;


type DataUserType = {
  _id: string;
  teamId: string;
  userId: string;
  __v: number;
  email: string;
  isAdmin: boolean;
  kudosGiveable: number;
  kudosGranted: number;
  kudosSpendable: number;
  name: string;
  realName: string;
  userName: string;
  teamName?: string;
}
interface ChartData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    backgroundColor: string[];
    borderColor: string;
    borderWidth: number;
  }[];
}

const StatisticalsPage: React.FC = () => {
  const currentDate = new Date();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  const adjustedfirstDayOfMonth = formatDateWithTimezoneOffset(firstDayOfMonth, 7);
  const adjustedlastDayOfMonth = formatDateWithTimezoneOffset(lastDayOfMonth, 7);
  const [DataUsers] = useState<DataUserType[]>([]);
  const [startDate, setStartDate] = useState<string | null>(adjustedfirstDayOfMonth);
  const [endDate, setEndDate] = useState<string | null>(adjustedlastDayOfMonth);
  const [typeKudos] = useState<string>('kudosGranted');
  const [selectedTeam, setSelectedTeam] = useState<string>('ALL');
  const [FilterTeam] = useState<any[]>([
    { teamName: 'Total All Team Company ', value: "ALL" },
    { teamName: 'Team CLIENT', value: "CLIENT" },
    { teamName: 'Team TESTER', value: "TESTER" },
    { teamName: 'Team SERVER', value: "SERVER" },
    { teamName: 'Team MARKETING', value: "MARKETING" },
    { teamName: 'Team CEO', value: "CEO" },
    { teamName: 'Team OTHER', value: "OTHER" },
  ]);
  const [chartDataUser, setChartDataUser] = useState<ChartData>({
    labels: [],
    datasets: [
      {
        label: '',
        data: [],
        backgroundColor: [],
        borderColor: '',
        borderWidth: 1,
      },
    ],
  });
  const [chartDataTeam, setChartDataTeam] = useState<ChartData>({
    labels: [],
    datasets: [
      {
        label: '',
        data: [],
        backgroundColor: [],
        borderColor: '',
        borderWidth: 1,
      },
    ],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const currentDate = new Date();
        const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
        const defaultEndDate = formatDateWithTimezoneOffset(currentDate, 7) + 1;
        const adjustedStartDate = formatDateWithTimezoneOffset(nextMonth, 7);

        const params: any = {
          startDate: startDate || adjustedStartDate,
          endDate: endDate || defaultEndDate
        };

        if (selectedTeam && selectedTeam !== 'ALL') {
          params.teamName = selectedTeam;
        }

        if (typeKudos) {
          params.type = typeKudos;
        }
        const response = await axios.get('/api/transfers/users-charts', { params });
        const { CLIENT, SERVER, MARKETING, TESTER, CEO, OTHER } = response.data;
        const kudosData = [CLIENT, SERVER, MARKETING, TESTER, CEO, OTHER];
        const labels = ["CLIENT", "SERVER", "MARKETING", "TESTER", "CEO", "OTHER"];

        setChartDataUser({
          labels,
          datasets: [
            {
              label: typeKudos,
              data: kudosData,
              backgroundColor: ["rgba(75,192,192,1)", "#50AF95", "#f3ba2f", "#2a71d0"],
              borderColor: "black",
              borderWidth: 2
            }
          ]
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    const fetchTeamData = async () => {
      try {
        const currentDate = new Date();
        const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
        const defaultEndDate = formatDateWithTimezoneOffset(currentDate, 7) + 1;
        const adjustedStartDate = formatDateWithTimezoneOffset(nextMonth, 7);

        const params: any = {
          startDate: startDate || adjustedStartDate,
          endDate: endDate || defaultEndDate,
          top: "false"
        };

        if (selectedTeam && selectedTeam !== 'ALL') {
          params.teamName = selectedTeam;
        }

        const response = await axios.get('/api/transfers/users-charts', { params });
        const { data } = response;
        let kudosData: number[] = [];
        let labelsData: string[] = [];

        if (data?.docs && data.docs[selectedTeam]) {
          const teamData = data.docs[selectedTeam];
          labelsData = Object.keys(teamData);
          kudosData = labelsData.map(username => teamData[username].totalValue);
        }

        setChartDataTeam({
          labels: labelsData,
          datasets: [
            {
              label: typeKudos,
              data: kudosData,
              backgroundColor: ["rgba(75,192,192,1)", "#50AF95", "#f3ba2f", "#2a71d0"],
              borderColor: "black",
              borderWidth: 2
            }
          ]
        });


      } catch (error) {
        console.error('Error fetching data Team:', error);
      }
    };
    fetchTeamData();
    fetchData();
  }, [selectedTeam, typeKudos, startDate, endDate, DataUsers]);

  const handleTeamChange = (value: string) => {
    setSelectedTeam(value);
  };


  const handleDateChange = (dates: [dayjs.Dayjs, dayjs.Dayjs] | null, dateStrings: [string, string]) => {
    if (dates && dateStrings) {
      setStartDate(dateStrings[0]);
      const endDate = new Date(dateStrings[1]);
      endDate.setDate(endDate.getDate() + 1);
      const incrementedEndDateString = endDate.toISOString().split('T')[0];
      setEndDate(incrementedEndDateString);
    }
  };

  return (
    <div className="container">
              <Typography.Title level={2}>Statisticals</Typography.Title>
      <Divider />
      <div style={{ 
        padding: '24px',
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)'
      }}>
        <div style={{ 
          display: 'flex',
          gap: '16px',
          marginBottom: '24px',
          flexWrap: 'wrap'
        }}>
          <div style={{ flex: '1', minWidth: '300px' }}>
            <div style={{ marginBottom: '8px' }}>
              <label style={{ 
                fontSize: '14px',
                fontWeight: 500,
                color: '#262626'
              }}>
                Khoảng Thời Gian
              </label>
            </div>
            <StableDatePicker
              style={{
                width: "100%",
                borderRadius: "6px"
              }}
              onChange={handleDateChange}
              defaultValue={[
                dayjs(adjustedfirstDayOfMonth),
                dayjs(adjustedlastDayOfMonth),
              ]}
              format="DD/MM/YYYY"
              allowClear={false}
              placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
            />
          </div>

          <div style={{ flex: '1', minWidth: '300px' }}>
            <div style={{ marginBottom: '8px' }}>
              <label style={{ 
                fontSize: '14px',
                fontWeight: 500,
                color: '#262626'
              }}>
                Chọn Team
              </label>
            </div>
            <Select 
              value={selectedTeam} 
              onChange={handleTeamChange}
              style={{ width: '100%' }}
            >
              {FilterTeam.map((data, index) => (
                <Option key={index} value={data.value}>
                  {data.teamName}
                </Option>
              ))}
            </Select>
          </div>
        </div>
      </div>
      <div>
        <BarChart chartData={chartDataUser} type="team" />
      </div>
      <div>
        <BarChart chartData={chartDataTeam} type="user" />
      </div>
    </div>
  );
};

export default StatisticalsPage;